module.exports = __webpack_public_path__ + "img/line_pattern.15366a58.webp";